import React from 'react';
import { Reveal, RevealItem } from './Reveal';
export const PainSection = () => {
  return <section className="py-10 md:py-14 pb-6 md:pb-10 px-[5vw] bg-bg" data-id="element-332">
      <div className="max-w-6xl mx-auto" data-id="element-333">
        <Reveal data-id="element-334">
          <div className="text-center mb-16" data-id="element-335">
            <span className="font-caveat text-rose text-2xl block mb-4" data-id="element-336">
              você não está sozinha
            </span>
            <h2 className="font-serif font-bold text-[clamp(34px,5vw,56px)] tracking-[-0.02em] text-ink max-w-3xl mx-auto" data-id="element-337">
              Se algum desses pensamentos já te tirou o sono…
            </h2>
          </div>
        </Reveal>

        <Reveal stagger data-id="element-338">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-339">
            {/* Card 1 */}
            <RevealItem className="bg-rose-soft rounded-[24px] md:rounded-[32px] p-6 md:p-8 relative overflow-hidden" data-id="element-340">
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-rose rounded-full opacity-10" data-id="element-341"></div>
              <p className="font-serif italic text-[18px] md:text-[20px] text-ink mb-4 relative z-10" data-id="element-342">
                "Trabalhei tanto esse mês. Cadê o dinheiro?"
              </p>
              <p className="text-[14px] text-ink-soft relative z-10" data-id="element-343">
                Você vendeu, entregou, fez bonito, mas no dia 30 olha pro
                extrato e não entende. O dinheiro entrou, saiu e você não faz
                ideia de onde foi parar.
              </p>
            </RevealItem>

            {/* Card 2 */}
            <RevealItem className="bg-gold-soft rounded-[24px] md:rounded-[32px] p-6 md:p-8 relative overflow-hidden" data-id="element-344">
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-gold rounded-full opacity-10" data-id="element-345"></div>
              <p className="font-serif italic text-[18px] md:text-[20px] text-ink mb-4 relative z-10" data-id="element-346">
                "Eu chuto o preço. Sempre chutei."
              </p>
              <p className="text-[14px] text-ink-soft relative z-10" data-id="element-347">
                Você multiplica o material por 3 "e tá bom". Mas esquece o gás,
                esquece a embalagem e só descobre tarde que vendeu no prejuízo
                achando que tava lucrando.
              </p>
            </RevealItem>

            {/* Card 3 */}
            <RevealItem className="bg-green-soft rounded-[24px] md:rounded-[32px] p-6 md:p-8 relative overflow-hidden" data-id="element-348">
              <div className="absolute -top-10 -right-10 w-32 h-32 bg-ink rounded-full opacity-5" data-id="element-349"></div>
              <p className="font-serif italic text-[18px] md:text-[20px] text-ink mb-4 relative z-10" data-id="element-350">
                "O leite condensado subiu de novo e eu travei."
              </p>
              <p className="text-[14px] text-ink-soft relative z-10" data-id="element-351">
                Você sabe que precisa repassar, mas tem medo da cliente
                reclamar. Aí engole o aumento. E o seu lucro vai junto, sem você
                perceber.
              </p>
            </RevealItem>
          </div>
        </Reveal>
      </div>
    </section>;
};